import { render, staticRenderFns } from "./AdminBrands.vue?vue&type=template&id=4ec8962c&scoped=true&"
import script from "./AdminBrands.vue?vue&type=script&lang=js&"
export * from "./AdminBrands.vue?vue&type=script&lang=js&"
import style0 from "./AdminBrands.vue?vue&type=style&index=0&id=4ec8962c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec8962c",
  null
  
)

export default component.exports